/* eslint-disable class-methods-use-this */
import { EntityDto, PagedResultDto } from 'services/dto';
import http from '../httpService';

import { IResult } from '@models';
import {
  CreateRequest,
  PagedRequestDto,
  RequestDto,
  RequestedRequest,
  UpdateRequest,
} from './dto/request';

class RequestService {
  public async getAll(
    pagedFilterAndSortedRequest: PagedRequestDto
  ): Promise<PagedResultDto<RequestedRequest>> {
    const result = await http.get('api/services/app/Request/getAllRequested', {
      params: pagedFilterAndSortedRequest,
    });
    return result.data.result;
  }
  public async get(entityDto: EntityDto<string>): Promise<RequestDto> {
    const result = await http.get('api/services/app/Request/Get', {
      params: entityDto,
    });
    return result.data.result;
  }

  public async delete(entityDto: EntityDto<string>) {
    const result = await http.delete('api/services/app/Request/Delete', { params: entityDto });
    return result.data;
  }

  public async create(request: CreateRequest) {
    const result = await http.post('api/services/app/Request/Create', request);
    return result.data;
  }

  public async update(request: UpdateRequest): Promise<RequestDto> {
    const result = await http.put('api/services/app/Request/Update', request);
    return result.data;
  }

  public async getTotalCount(status: string) {
    const response = await http.get<IResult<number>>(
      'api/services/app/Request/GetTotalCount?status=' + status
    );
    return response.data.result;
  }
}

export default new RequestService();
